var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-font"},[_vm._v(" 欢迎使用数据采集平台 ")])}
var staticRenderFns = []

export { render, staticRenderFns }